import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "reset-pass"
};
const _hoisted_2 = {
  class: "form"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { computed, ref } from "vue";
import SendMsg from "@/components/SendMsg.vue";
import { ElMessage } from "element-plus";
import { httpPost } from "@/utils/http";
import { validateEmail, validateMobile } from "@/utils/validate";
export default {
  __name: 'ResetPass',
  props: {
    show: Boolean,
    mobile: String
  },
  emits: ["hide"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const showDialog = computed(() => {
      return props.show;
    });
    const title = ref("重置密码");
    const form = ref({
      mobile: "",
      email: "",
      type: "mobile",
      code: "",
      password: "",
      repass: ""
    });
    const emits = __emit;
    const save = () => {
      if (form.value.code === "") {
        return ElMessage.error("请输入验证码");
      }
      if (form.value.password.length < 8) {
        return ElMessage.error("密码长度必须大于8位");
      }
      if (form.value.repass !== form.value.password) {
        return ElMessage.error("两次输入密码不一致");
      }
      httpPost("/user/resetPass", form.value).then(() => {
        ElMessage.success({
          message: "重置密码成功",
          duration: 1000,
          onClose: () => emits("hide", false)
        });
      }).catch(e => {
        ElMessage.error("重置密码失败：" + e.message);
      });
    };
    const close = function () {
      emits("hide", false);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showDialog.value = $event),
        "close-on-click-modal": true,
        width: "500px",
        "before-close": close,
        title: title.value,
        class: "reset-pass-dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: save,
          round: ""
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" 重置密码 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "80px",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: form.value.type,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.type = $event),
            class: "demo-tabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "手机号验证",
              name: "mobile"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "手机号"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.mobile,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.mobile = $event),
                  placeholder: "请输入手机号"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "验证码"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
                  modelValue: form.value.code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.code = $event),
                  maxlength: "6",
                  class: "mr-2 w-1/2"
                }, null, 8, ["modelValue"]), _createVNode(SendMsg, {
                  size: "",
                  receiver: form.value.mobile,
                  type: "mobile"
                }, null, 8, ["receiver"])])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              label: "邮箱验证",
              name: "email"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "邮箱地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.email = $event),
                  placeholder: "请输入邮箱地址"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "验证码"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
                  modelValue: form.value.code,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.code = $event),
                  maxlength: "6",
                  class: "mr-2 w-1/2"
                }, null, 8, ["modelValue"]), _createVNode(SendMsg, {
                  size: "",
                  receiver: form.value.email,
                  type: "email"
                }, null, 8, ["receiver"])])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_form_item, {
            label: "新密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.password = $event),
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "重复密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.repass,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.repass = $event),
              type: "password"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};